import axios from 'axios';
import qs from 'qs';
import contentService from '../../services/contentService';

import {
  FETCH_ARTICLES_CATEGORYPAGE_SUCCESS,
  FETCH_ARTICLES_CITY_SUCCESS,
  FETCH_ARTICLES_CLEAN_UP,
  FETCH_ARTICLES_FAILURE,
  FETCH_ARTICLES_HOMEPAGE_SUCCESS,
  FETCH_ARTICLES_PUBLISHER_SECTION_SUCCESS,
  FETCH_ARTICLES_REQUEST,
  FETCH_ARTICLES_SUCCESS,
} from '../constants/articlesTypes';

const fetchArticlesRequest = () => {
  return {
    type: FETCH_ARTICLES_REQUEST,
  };
};

const fetchArticlesSuccess = (payload) => {
  return {
    type: FETCH_ARTICLES_SUCCESS,
    payload,
  };
};

const fetchArticlesFailure = (error) => {
  return {
    type: FETCH_ARTICLES_FAILURE,
    payload: error,
  };
};

const fetchArticlesByCitySuccess = (payload) => {
  return {
    type: FETCH_ARTICLES_CITY_SUCCESS,
    payload,
  };
};

const fetchArticlesHomepageSuccess = (payload) => {
  return {
    type: FETCH_ARTICLES_HOMEPAGE_SUCCESS,
    payload,
  };
};

const fetchArticlesCategoryPageSuccess = (payload) => {
  return {
    type: FETCH_ARTICLES_CATEGORYPAGE_SUCCESS,
    payload,
  };
};

const fetchArticlesPublisherSectionSuccess = (payload) => {
  return {
    type: FETCH_ARTICLES_PUBLISHER_SECTION_SUCCESS,
    payload,
  };
};

export const fetchArticlesCleanUp = () => {
  return {
    type: FETCH_ARTICLES_CLEAN_UP,
  };
};

export const fetchArticles = ({
  categories = [],
  city = undefined,
  start = undefined,
  limit = undefined,
  menuName = '',
  slug = undefined,
  locale = 'de',
} = {}) => {
  return (dispatch) => {
    let categoriesList = [];
    let query = '';
    categoriesList = categories.map((item) => item.id);
    if (categoriesList.length > 0) {
      query = qs.stringify(
        {
          _where: { 'categories.id': categoriesList },
        },
        { encode: false, arrayFormat: 'repeat' }
      );
    }
    const contentsQuery = `sort=publishAt%3Adesc&filters[type][$eq]=article&populate[main_image]=true${
      categoriesList.length > 0 ? `&${query}` : ''
    }${menuName ? `&filters[menu][$eq]=${menuName}` : ''}${
      city ? `&filters[city][$eq]=${city}` : ''
    }${start ? `&pagination[start]=${start}` : ''}${
      limit ? `&pagination[limit]=${limit}` : ''
    }${slug ? `&filters[slug][$ne]=${slug}` : ''}`;
    dispatch(fetchArticlesRequest);
    contentService
      .getContents(contentsQuery, locale)
      .then((response) => {
        const articles = response.data;
        dispatch(
          fetchArticlesSuccess({
            articles,
            limit,
            start,
          })
        );
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchArticlesFailure(errorMsg));
      });
  };
};

export const fetchArticleHomepage = ({ locale = 'de' }) => {
  return (dispatch) => {
    const queries = [
      'sort=publishAt%3Adesc&filters[homepage][$eq]=main_article&pagination[limit]=1&populate[main_image]=true',
      'sort=publishAt%3Adesc&filters[homepage][$eq]=publisher&populate[main_image]=true',
      'sort=publishAt%3Adesc&filters[menu][$eq]=goodnews&pagination[limit]=4&populate[main_image]=true',
      'sort=publishAt%3Adesc&filters[menu][$eq]=gesundekommune&filters[menu][$eq]=wissen&pagination[limit]=4',
      'sort=publishAt%3Adesc&filters[menu][$eq]=bildung&pagination[limit]=4&populate[main_image]=true',
      'sort=publishAt%3Adesc&filters[menu][$eq]=projekte&pagination[limit]=4',
    ];
    dispatch(fetchArticlesRequest);
    Promise.all(
      queries.map((query) => contentService.getContents(query, locale))
    )
      .then(
        ([
          mainArticleResponse,
          publisherResponse,
          newsResponse,
          wissenResponse,
          gtTippsResponse,
          projekteResponse,
        ]) => {
          const mainArticle = mainArticleResponse.data[0];
          const publisherArticles = publisherResponse.data;
          const newsArticles = newsResponse.data;
          const wissenArticles = wissenResponse.data;
          const gtTippsArticles = gtTippsResponse.data;
          const projekteArticles = projekteResponse.data;
          const articles = {
            mainArticle,
            publisherArticles,
            newsArticles,
            wissenArticles,
            gtTippsArticles,
            projekteArticles,
          };
          dispatch(fetchArticlesHomepageSuccess({ articles }));
        }
      )
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchArticlesFailure(errorMsg));
      });
  };
};

export const fetchArticlesPublisherSection = ({
  start = undefined,
  limit = undefined,
}) => {
  return (dispatch) => {
    const urlPublisher = `${
      process.env.REACT_APP_CMS_URL
    }/contents?sort=publishAt%3Adesc&filters[homepage][$eq]=publisher${
      start ? `&pagination[start]=${start}` : ''
    }${limit ? `&pagination[limit]=${limit}` : ''}`;
    dispatch(fetchArticlesRequest);
    axios
      .all([axios.get(urlPublisher)])
      .then(
        axios.spread((...responses) => {
          const publisherArticles = responses[0].data;
          // const articles = {
          //     publisherArticles: publisherArticles.data,
          // };
          dispatch(
            fetchArticlesPublisherSectionSuccess({
              publisherArticles,
            })
          );
        })
      )
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchArticlesFailure(errorMsg));
      });
  };
};

export const fetchArticleCategoryPage = () => {
  return (dispatch) => {
    const urlNews = `${process.env.REACT_APP_CMS_URL}/contents?sort=publishAt%3Adesc&filters[homepage][$eq]=news&pagination[limit]=5`;
    dispatch(fetchArticlesRequest);
    axios
      .all([axios.get(urlNews)])
      .then(
        axios.spread((...responses) => {
          const newsArticles = responses[0];
          const articles = {
            newsArticles: newsArticles.data,
          };
          dispatch(fetchArticlesCategoryPageSuccess({ articles }));
        })
      )
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchArticlesFailure(errorMsg));
      });
  };
};

export const fetchArticlesCity = ({
  limit = undefined,
  start = undefined,
  place = { lat: 52.56, lng: 13.14 },
  radius = 200001,
}) => {
  const { lat, lng } = place;
  return (dispatch) => {
    const url = `${process.env.REACT_APP_CMS_URL}/geodata?lat=${lat}&lng=${lng}&radius=${radius}&type=article&start=${start}&limit=${limit}`;
    dispatch(fetchArticlesRequest);
    axios
      .get(url)
      .then((response) => {
        const { articles } = response.data;
        dispatch(
          fetchArticlesByCitySuccess({
            articles,
            limit,
          })
        );
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(fetchArticlesFailure(errorMsg));
      });
  };
};
